import React from "react";
import Select from "react-select";

export function CommomSelect({ name, value, options, onChange, showSearch }) {
  return (
    <>
      <label className="font-weight-bolder font-size-lg">{name}</label>
      <Select
        isClearable={true}
        value={value}
        placeholder={name}
        style={{
          width: "100%",
        }}
        options={options}
        showSearch={showSearch}
        onChange={onChange}
      />
    </>
  );
}
